import { Locale } from "i18n/config";

export function convertToPercentStr(decimal: number, locale: Locale) {
  return decimal.toLocaleString(locale, {
    style: "percent",
    minimumSignificantDigits: 2,
  });
}
